import * as React from 'react';

import challengeSettings from '../../../settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { FCWithChildren } from '@wix/challenges-web-library';
import { getBidirectionalAlignment } from '../../../../../utils/GetBidirectionalAlignment';
import { useCSSPBEnabled } from '../../../../../hooks/useCSSPBStyle';
import { st, classes } from './SidebarControlsContainer.st.css';

export interface IDividerProps {
  className?: string;
  direction?: 'column' | 'row';
}

export const SidebarControlsContainer: FCWithChildren<IDividerProps> = (
  props,
) => {
  const { direction = 'row' } = props;
  const settings = useSettings();
  const { isMobile, isRTL } = useEnvironment();
  const align = getBidirectionalAlignment(
    settings.get(challengeSettings.sidebarLayoutTextAlignment),
    isRTL,
  );
  const cssPBEnabled = useCSSPBEnabled({
    includeParticipantPageAlignmentCheck: true,
  });

  return (
    <div
      className={st(
        classes.root,
        {
          align: !cssPBEnabled ? align : null,
          withCSSAlignment: cssPBEnabled,
          direction,
          mobile: isMobile,
        },
        props.className,
      )}
      dir="auto"
    >
      {props.children}
    </div>
  );
};
